var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-view"},[_c('div',{staticClass:"progress-container"},[_c('b-progress',{attrs:{"type":"is-primary","size":"is-small"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }